import { useCallback, useState } from "react";

export type SortDirections = "asc" | "desc";

export interface SortState<T> {
  key?: keyof T;
  direction?: SortDirections;
}

const useSort = <T>(initialValue: SortState<T>) => {
  const [state, setState] = useState<SortState<T>>(initialValue);

  const updateState = useCallback((key: keyof T) => {
    setState(currentState => {
      if (key === currentState.key) {
        return {
          key: currentState.key,
          direction: currentState.direction === "asc" ? "desc" : "asc"
        };
      }

      return {
        key,
        direction: "asc"
      };
    });
  }, []);

  return [state, updateState] as const;
};

export default useSort;
